import { Http } from "../axios/interceptors";

export const allAppointmentsProducts = async (param) =>
  Http("GET", `/AppointmentsProducts/GetByList?`, param);

export const getAppointmentProduct = async (guid) =>
  Http("GET", `/AppointmentsProducts/Get?idAppointment=${guid}`);

export const createOrEditAppointmentProduct = async (body, id = null) =>
  id
    ? Http("PUT", `/AppointmentsProducts/Update`, null, body)
    : Http("POST", "/AppointmentsProducts/Create", null, body);

export const deleteAppointmentProduct = async (guid) =>
  Http("DELETE", `/AppointmentsProducts/Delete?idAppointment=${guid}`);

export const statusChangesAppointmentProduct = async (body) =>
  Http("PUT", `/AppointmentsProducts/StatusChanges`, null, body);
